import RemoteSubmitButton from './RemoteSubmitButton'

export default RemoteSubmitButton